import type { StepMessageProps } from 'features/executions/types'

import { FullLoader } from 'components/atoms/FullLoader/FullLoader'
import { useId, useRef } from 'react'
import { useSyncPopoverState } from 'shared/hooks/useSyncPopoverState'

import { api } from '../../api'
import css from './MessagePreview.module.css'

export function MessagePreview(props: StepMessageProps) {
	const id = useId()
	const ref = useRef<HTMLDivElement | null>(null)
	const isOpen = useSyncPopoverState(ref)

	const query = api.useStepMessageQuery(props, {
		skip: !isOpen
	})

	return (
		<>
			<button
				className={css.openTrigger}
				// @ts-ignore Recheck in React 19
				popovertarget={id}
				popovertargetaction='toggle'
				type='button'
			>
				message
			</button>

			<article
				className={css.wrapper}
				id={id}
				// @ts-ignore Recheck in React 19
				popover='auto'
				ref={ref}
			>
				<hgroup>
					<p className={css.subtitle}>{`Action #${props.step}`}</p>
					<h4 className={css.title}>Message</h4>
				</hgroup>

				{query.isFetching ? (
					<FullLoader size={18} />
				) : (
					<blockquote className={css.text}>{query.currentData}</blockquote>
				)}
			</article>
		</>
	)
}

export function MessageTextPreview({ text }: { text: string }) {
	const id = useId()
	const ref = useRef<HTMLDivElement | null>(null)

	return (
		<>
			<button
				className={css.openTrigger}
				// @ts-ignore Recheck in React 19
				popovertarget={id}
				popovertargetaction='toggle'
				type='button'
			>
				message
			</button>

			<article
				className={css.wrapper}
				id={id}
				// @ts-ignore Recheck in React 19
				popover='auto'
				ref={ref}
			>
				<hgroup>
					<h4 className={css.title}>Message</h4>
				</hgroup>
				<blockquote className={css.text}>{text}</blockquote>
			</article>
		</>
	)
}
